import * as React from 'react';
import { Dispatch, connect } from 'react-redux';
import { AppActionCreators, CenterActionCreators, IApplicationState } from '@nkr/store/index';
import { IAdminRelativePerformanceResponse } from '@nkr/store/center/actions';
import { IAdminRelativePerformance } from '@nkr/models/index';
import Grid  from './grid'
import { ColumnApi, CsvExportParams, GridApi, GridReadyEvent, ProcessCellForExportParams } from 'ag-grid-community';
import { Button, Row } from 'react-bootstrap';

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getAdminRelativePerformance: () => Promise<IAdminRelativePerformanceResponse>
}


interface IState {
    data: IAdminRelativePerformance[]
}

type TProps = IDispatchProps

class AdminRelativePerformance extends React.Component<TProps, IState> {
    readonly state: IState ={
        data: null
    }

    gridApi: GridApi = null;
    gridColumnApi: ColumnApi = null;

    onGridReady = (e: GridReadyEvent) => {
        this.gridApi = e.api;
        this.gridColumnApi = e.columnApi;

        e.api.sizeColumnsToFit();
    }

    handleExport = () => {
        let params: CsvExportParams = {
            fileName: 'relative-performance.csv',
            processCellCallback: (params: ProcessCellForExportParams) => {
                return params.value != null ? params.value.toString() : '';
            }
        };

        this.gridApi.exportDataAsCsv(params);
    }

    componentDidMount = () => {
        this.getData();
    }

    getData = () => {
        this.props.showLoading('Loading the data, this may take a few minutes...').then(() => {
            this.props.getAdminRelativePerformance().then((res) => {
                if (res.data.success) {
                    this.setState({
                        data: res.data.results
                    }, () => {
                        this.props.hideLoading();
                    })
                }
            })
        }).catch((error) => {
            this.props.hideLoading();
        })
    }

    render = () =>{

        return (
            <>
                <Row>
                    <Button style={{margin: '10px', float: 'right' }} onClick={this.handleExport}>Export to CSV/Excel</Button>
                </Row>
                <Grid
                    data={this.state.data}
                    onGridReady={this.onGridReady}
                />
            
            </>
        )
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getAdminRelativePerformance: () => {
            return dispatch(CenterActionCreators.getAdminRelativePerformance())
        }
    }
}

export default connect<{}, IDispatchProps, {}>(
    null,
    mapDispatchToProps
) (AdminRelativePerformance)